import React from 'react';
import './AboutUsSection.css';

const AboutUsSection = ({ config }) => {
  return (
    <div className="about-us-section">
      <div className="about-us-content">
        <div className="about-us-text">
          <h2 className="about-us-title">{config.title}</h2>
          <div className="about-us-description">
            {config.paragraphs.map((paragraph, index) => (
              <p key={index} className="about-us-paragraph">
                {paragraph}
              </p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUsSection;
